import { render, staticRenderFns } from "./RecordNotFound.vue?vue&type=template&id=3584d7fb&scoped=true"
import script from "./RecordNotFound.vue?vue&type=script&lang=js"
export * from "./RecordNotFound.vue?vue&type=script&lang=js"
import style0 from "./RecordNotFound.vue?vue&type=style&index=0&id=3584d7fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584d7fb",
  null
  
)

export default component.exports